export default "__VITE_ASSET__gIYIlMJc__"